import { Section, Center, Row, Col } from '@styled/global';
import styled from 'vue-styled-components';
import 'styled-system';

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n   clip: rect(1px, 1px, 1px, 1px) !important;\n   position: absolute;\n   left: -10000px;\n   top: auto;\n   width: 1px;\n   height: 1px;\n   overflow: hidden;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n   margin: 0 0 0 10px;\n   width: 80px;\n   cursor: pointer;\n   padding: 4px 10px 4px 10px;\n   color: #fff;\n   background: #007582;\n   border-radius: 6px;\n   -webkit-font-smoothing: antialiased;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n   color: #007582;\n   font-size: 16px;\n   line-height: 24px;\n   margin: 0 10px 0 0;\n   -webkit-font-smoothing: antialiased;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n   border: solid #d1c9c0;\n   border-width: 1px 2px 2px 1px;\n   color: #524940;\n   margin: 0;\n   padding: 0 10px;\n   box-shadow: none;\n   background-color: #fff;\n   background-position: 100% center;\n   background-repeat: no-repeat;\n   -webkitappearance: none !important;\n   font-size: 16px;\n   line-height: normal;\n   text-aling: center;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var Select = styled("select", {})(_templateObject());
var Option = styled("option", {})(_templateObject2());
var Label = styled("label", {})(_templateObject3());
var Button = styled("button", {})(_templateObject4());
var ADA = styled("span", {})(_templateObject5());

var script = {
  props: {
    copy: {
      required: true,
      type: Object
    }
  },
  methods: {
    // Render state option list
    renderOptions: function renderOptions(h) {
      return this.copy.states.map(function (item) {
        return h(Option, [item.name]);
      });
    }
  },
  render: function render(context) {
    var h = arguments[0];
    var copy = this.copy;
    var cta = copy.cta;
    return h(Section, [h(Center, [h(Row, [h(Col, {
      "attrs": {
        "width": [12, 12, 4, 5],
        "justifyContent": ["center", "center", "flex-end"],
        "flexDirection": "row"
      }
    }, [h(Label, [copy.label])]), h(Col, {
      "attrs": {
        "width": [12, 12, 4, 2],
        "justifyContent": "center",
        "flexDirection": "row"
      }
    }, [h(Select, [this.renderOptions(context)])]), h(Col, {
      "attrs": {
        "width": [12, 12, 4, 5],
        "justifyContent": ["center", "center", "flex-start"],
        "flexDirection": "row"
      }
    }, [h(Button, [h("RouterLink", {
      "attrs": {
        "to": cta.url,
        "id": cta.id
      }
    }, [cta.label, h(ADA, [cta.ada])])])])])])]);
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function (context) {
      style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}

/* script */
const __vue_script__ = script;

/* template */

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = undefined;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = normalizeComponent(
    {},
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
